<template>
  <asd20-school-details
    v-if="school"
    :school="school" />
</template>

<script>
import { get } from 'vuex-pathify'
import Asd20SchoolDetails from '@/components/organisms/Asd20SchoolDetails'

export default {
  name: 'Asd20SchoolDetailsPage',
  components: { Asd20SchoolDetails,  },

  computed: {
    school: get('school/schoolWithMetadata'),
  },

  beforeRouteUpdate () {
    this.getSchool()
  },
  created () {
    this.getSchool()
  },
  methods: {
    async getSchool() {
      if (!this.$route || !this.$route.params || !this.$route.params.school_abbreviation) return
      let school = await this.$store.dispatch('school/getSchool', this.$route.params.school_abbreviation)
    }
  }

}
</script>

<style>
</style>
